const initializeClickableRowsContacts = function() {
    const rows = document.querySelectorAll(".clickable-row");

    rows.forEach(row => {
        row.addEventListener("click", function (e) {
            if (e.target.closest(".no-click")) {
                return;
            }
            // data-href: a row whose contact the user may not open links somewhere else (the order)
            const href = this.getAttribute("data-href");
            const contactId = this.getAttribute("data-contact-id");
            if (href) {
                window.location.href = href;
            } else if (contactId) {
                window.location.href = `/contacts/${contactId}`;
            }
        });
    });
}

const sendFormAsAjax = function (formElement, providedMethod = null, action = null, callback = null) {
    const url = action || formElement.action;
    const method = providedMethod || formElement.method || 'POST'; // Axios defaults to GET if not specified in config

    // Collect form data using FormData API
    const formData = new FormData(formElement);

    const formObject = {};
    formData.forEach((value, key) => {
        if (key.endsWith('[]')) {
            const arrayKey = key.slice(0, -2); // Remove '[]' from the key
            if (!formObject[arrayKey]) {
                formObject[arrayKey] = [];
            }
            formObject[arrayKey].push(value);
        } else {
            formObject[key] = value;
        }
    });

    axios({
        method: method.toLowerCase(),
        url: url,
        data: JSON.stringify(formObject),
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(response => {
        const data = response.data;
        if (data.success) {
            if (callback && typeof callback === 'function') {
                return callback(data);
            }

            window.location.reload();
        } else {
            alert("❌ Error: " + data.error);
        }
    })
        .catch(error => {
            console.error("❌ Error submitting:", error);
            // A network failure has no response to read the message from
            alert("⚠️ Error: " + (error.response?.data?.message || error.message));
        });
}

const generateSecret = function (target) {
    let result           = '';
    let characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let charactersLength = characters.length;
    let length = 32;

    for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    let element = document.querySelector(target);
    element.value = result;
}

// Escape a value for use inside an HTML string (text or a quoted attribute).
const escapeHtml = function (value) {
    return String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
}

module.exports = {
    initializeClickableRowsContacts,
    sendFormAsAjax,
    generateSecret,
    escapeHtml
}
